import { Box, Image } from "@chakra-ui/react";
import React from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import useCheckLogin from "../../../hook/useCheckLogin";

const ReloadButton = () => {
  // 取 登入狀態 機台相關的狀態
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  return (
    <Box
      onClick={() => {
        window.location.reload(); // 重新載入頁面
      }}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      shadow="sm"
    >
      <Image
        src={`${COMMON_WEB_PATH}/911TW/refresh.webp`}
        height={{
          base: isMachineUser ? "70px" : "30px",
          md: isMachineUser ? "70px" : "50px",
          xl: isMachineUser ? "70px" : "50px",
        }}
        //minW="50px"
        minW={{
          base: isMachineUser ? "70px" : "30px",
          md: isMachineUser ? "70px" : "50px",
          xl: isMachineUser ? "70px" : "50px",
        }}
      />
    </Box>
  );
};

export default ReloadButton;
